import { client, authHeaders } from 'repositories/client';
import { paths } from 'repositories/auth/paths';
import {
  InfoResponse,
  LoginResponse,
  SignUpResponse,
} from 'repositories/auth/responseType';

const login = async (
  email: string,
  password: string,
  userInvitationToken?: string
): Promise<LoginResponse> => {
  const params = new FormData();
  params.append('email', email);
  params.append('password', password);

  if (userInvitationToken) {
    params.append('user_invitation_token', userInvitationToken);
  }

  const response = await client.post<LoginResponse>(paths.sessions, params, {
    headers: await authHeaders(),
  });
  return response.data;
};

const logout = async (): Promise<void> => {
  await client.delete(paths.sessions, {
    headers: await authHeaders(),
  });
};

const signUp = async (
  transactionKey: string,
  password: string,
  name: string,
  locale: string,
  termsAccept: boolean,
  userInvitationToken?: string,
  infoFromOAuth?: {
    iosSpaOnetimeToken: string;
  }
): Promise<SignUpResponse> => {
  const params = new FormData();
  params.append('email_verification_transaction_key', transactionKey);
  params.append('password', password);
  params.append('name', name);
  params.append('locale', locale);
  if (termsAccept) {
    params.append('terms_accept', 'true');
  }

  if (userInvitationToken) {
    params.append('user_invitation_token', userInvitationToken);
  }

  if (infoFromOAuth) {
    params.append('ios_spa_onetime_token', infoFromOAuth.iosSpaOnetimeToken);
  }

  const response = await client.post<SignUpResponse>(paths.users, params, {
    headers: await authHeaders(),
  });
  return response.data;
};

const info = async (authorizationToken: string): Promise<InfoResponse> => {
  const response = await client.get<InfoResponse>(paths.info, {
    headers: await authHeaders({ authorizationToken }),
  });

  return response.data;
};

export const auth = {
  login,
  logout,
  signUp,
  info,
};
